module.exports = __webpack_public_path__ + "static/img/vedioPic.caa7418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vedioPic.png
// module id = k4E9
// module chunks = 1